export function getMailtoHref(email = '') {
  const trimmed = String(email).trim()
  if (!trimmed) return undefined
  if (trimmed.toLowerCase().startsWith('mailto:')) return trimmed
  return `mailto:${trimmed}`
}

export function getTelHref(phone = '', countryCode = '91') {
  const digits = String(phone).replace(/\D/g, '')
  return digits ? `tel:+${countryCode}${digits}` : undefined
}

function openProtocolLink(href, event) {
  if (!href) return

  if (event) {
    event.preventDefault()
  }

  const anchor = document.createElement('a')
  anchor.href = href
  anchor.rel = 'noopener noreferrer'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

/** Opens the default mail client with the address in the To field. */
export function openMailto(email, event) {
  openProtocolLink(getMailtoHref(email), event)
}

export function openTel(phone, event, countryCode = '91') {
  openProtocolLink(getTelHref(phone, countryCode), event)
}
